/* StaticReaction.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import "./StaticReaction.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Pressable } from '@atlaskit/primitives/compiled';
var styles = {
  staticReaction: "_1reo15vq _18m915vq _19itglyw _2rkoglpi _1e0c1txw _2lx2vrvc _4cvr1y6m _1ul914no _4t3i1tcg _bfhksm61 _syaz1gjq _1pfh1b66 _12l21b66 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0al73ad _irr3166n"
};
export var StaticReaction = function StaticReaction(_ref) {
  var onMouseEnter = _ref.onMouseEnter,
    onFocus = _ref.onFocus,
    children = _ref.children,
    testId = _ref.testId,
    _ref$dataAttributes = _ref.dataAttributes,
    dataAttributes = _ref$dataAttributes === void 0 ? {} : _ref$dataAttributes;
  return /*#__PURE__*/React.createElement(Pressable, _extends({
    onMouseEnter: onMouseEnter,
    onFocus: onFocus,
    testId: testId,
    xcss: styles.staticReaction
  }, dataAttributes), children);
};